import { reasonsModel } from './reasons.model';
import { supportOfficers } from './supportOfficers.model';

export class exclusionsModel {
  exclusionId?;
  category?;
  categoryExtCode?;
  primaryReason?;
  startDate?;
  endDate?;
  meetings?;
  documentCount?;
  baseName?;
  academicYear?;
  reasonsList?;
  reasons?: reasonsModel[];
  meetingFlag?;
  headPrinciple?;
  excludedDays?;
  pastoralRecd?;
  ethnicity?;
  senStageWhenExcluded?;
  supportOfficer?: supportOfficers[];
  baseId?: number;
  term?: string;
  studentId?: number;
  reinstatedWithdrawnReasonDate?;
  startTime?;
  endTime?;
  dateOffRoll?;
  endMonitorDate?;
  sixthDay?;
  inCareWhenExcluded?;
  ncyWhenExcluded?;
  excludedLunchTimes?;
  excludedDaysOffset?;
  excludedDaysToDate?;
  reinstatedWithdrawnReason?;
  priority?;
  dfeNumber?: string;

  public constructor(init?: Partial<exclusionsModel>) {
    Object.assign(this, init);
  }
}
